module.exports = __webpack_public_path__ + "img/crown@2x.56bd2e6.jpg";